module.exports = __webpack_public_path__ + "static/media/entreprenuer-story.7a20554e.svg";